import { Card, SummaryList } from 'nhsuk-react-components';
import { Link } from 'react-router-dom';
import { SummaryReport } from 'schemas/SummaryReport.schema';
import {
  unixTimestampToHumanReadableDate,
  unixTimestampToHumanReadableTime,
} from 'utils/formattingUtils';
import { Iteration } from 'schemas/Iteration.schema.ts';
import SummaryReportListStatusTag from 'components/SummaryReport/SummaryReportListStatusTag.tsx';
import ReviewerMessage from 'components/SummaryReport/ReviewerMessage.tsx';
import { CampaignConfig } from 'schemas/CampaignConfig.schema.ts';

interface IReportListProps {
  reports: SummaryReport[],
  iteration: Iteration,
  campaign: CampaignConfig,
}

function ReportList({ reports, iteration, campaign }: IReportListProps) {
  return (
    <Card>
      {reports && reports.length > 0 && (
        <SummaryList>
          <SummaryList.Row>
            <SummaryList.Key>Report number</SummaryList.Key>
            <SummaryList.Key>Reviewed</SummaryList.Key>
            <SummaryList.Key>Status</SummaryList.Key>
          </SummaryList.Row>

          {reports.map((report, index, allReports) => (
            <SummaryList.Row
              className="summary-report-summary-list-row"
              key={report.summary_report_review?.timestamp ?? index}
            >
              <SummaryList.Value>
                <Link to={report.batch_id}>
                  <p className="nhsuk-body nhsuk-u-margin-top-1 nhsuk-u-margin-bottom-2">
                    {`Report ${index + 1}`}
                  </p>
                </Link>
                <p style={{ fontSize: '16px', fontWeight: 300 }}>
                  {report.dry_run ? 'Dry run' : 'Live run'}
                </p>
              </SummaryList.Value>
              <SummaryList.Value>
                <div className="nhsuk-u-secondary-text-colour">
                  <b>
                    <ReviewerMessage
                      report={report}
                      iteration={iteration}
                    />
                  </b>
                  <div>
                    {report.summary_report_review
                            && `${unixTimestampToHumanReadableDate(
                              report.summary_report_review.timestamp,
                            )} ${unixTimestampToHumanReadableTime(
                              report.summary_report_review.timestamp,
                            )}`}
                  </div>
                </div>
              </SummaryList.Value>
              <SummaryList.Value>
                <SummaryReportListStatusTag
                  report={report}
                  iteration={iteration}
                  campaign={campaign}
                  isLatestReport={index === allReports.length - 1}
                />
              </SummaryList.Value>
            </SummaryList.Row>
          ))}
        </SummaryList>
      )}
    </Card>
  );
}

export default ReportList;
